import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { pickFunction } from 'Helpers/Affordances';
import fr from 'facet-rest';
import {
  SecurityProfileSubpagePicker,
} from 'Views/Page/Content/Templates/Profile/Templates/ProfileTemplate/Subpages/SecurityProfileSubpage/SecurityProfileSubpagePicker';
import AuthenticationFactorTemplate from './AuthenticationFactorTemplate';

const styles = () => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
});

const SecurityTemplate = () => {
  const { pageContentResource } = usePageContentContext();

  return pickFunction(pageContentResource, {
    [fr.relationships.householdMembershipPage.name]: () => {
      return <SecurityProfileSubpagePicker resource={pageContentResource} />;
    },
    [fr.relationships.default.name]: () => {
      return <AuthenticationFactorTemplate />;
    },
  });
};

SecurityTemplate.defaultProps = {
  className: '',
};

SecurityTemplate.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SecurityTemplate);
